var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyStructure1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 112,
    viewBox: "0 0 101 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9428 112H3.74745C1.28407 112 -0.515521 107.859 0.133513 103.615L6.03382 64.5917C7.31714 56.0886 11.6391 50.1938 16.5806 50.1938H84.0801C89.0217 50.1938 93.3436 56.0886 94.6269 64.5917L100.527 103.615C101.206 107.859 99.4062 112 96.9428 112Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3452 0C59.883 0 69.0302 3.7853 75.7744 10.5232C82.5187 17.2611 86.3076 26.3996 86.3076 35.9284V71.8715H14.3828V35.9284C14.3828 26.3996 18.1717 17.2611 24.916 10.5232C31.6602 3.7853 40.8074 0 50.3452 0V0Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyStructure1);
export default __webpack_public_path__ + "static/media/body-structure1.fa2451c989537a98ce2bd72d33fb5db0.svg";
export { ForwardRef as ReactComponent };